import { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../../../contexts/AuthContext';

const ROLES = {
  ADMIN: 'ADMIN',
  DATA_MANAGER: 'DATA_MANAGER',
  LOGISTICS_COORDINATOR: 'LOGISTICS_COORDINATOR',
  AREA_COORDINATOR: 'AREA_COORDINATOR',
  CLIENT: 'CLIENT',
};

const PERMISSIONS = {
  CREATE_ORDER: 'order_add',
  EDIT_ORDER: 'order_change',
  DELETE_ORDER: 'order_delete',
  VIEW_ORDER: 'order_view',
  APPROVE_ORDER: 'order_approve',
  CONSOLIDATE_ORDERS: 'order_consolidate',
  EXECUTE_DELIVERY: 'order_execute_delivery'
};

const ROLE_PERMISSIONS = {
  [ROLES.ADMIN]: [
    PERMISSIONS.CREATE_ORDER,
    PERMISSIONS.EDIT_ORDER,
    PERMISSIONS.DELETE_ORDER,
    PERMISSIONS.VIEW_ORDER,
    PERMISSIONS.APPROVE_ORDER,
    PERMISSIONS.CONSOLIDATE_ORDERS,
    PERMISSIONS.EXECUTE_DELIVERY
  ],
  [ROLES.DATA_MANAGER]: [
    PERMISSIONS.VIEW_ORDER
  ],
  [ROLES.LOGISTICS_COORDINATOR]: [
    PERMISSIONS.CREATE_ORDER,
    PERMISSIONS.EDIT_ORDER,
    PERMISSIONS.VIEW_ORDER,
    PERMISSIONS.CONSOLIDATE_ORDERS,
    PERMISSIONS.EXECUTE_DELIVERY
  ],
  [ROLES.AREA_COORDINATOR]: [
    PERMISSIONS.VIEW_ORDER,
    PERMISSIONS.APPROVE_ORDER
  ],
  [ROLES.CLIENT]: [
    PERMISSIONS.VIEW_ORDER,
    PERMISSIONS.CREATE_ORDER
  ]
};

const usePermissions = () => {
  const { user } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const hasPermission = (permission) => {
    if (!user || !user.role) return false;
    const rolePermissions = ROLE_PERMISSIONS[user.role.name] || [];
    return rolePermissions.includes(permission);
  };

  const can = {
    createOrder: () => hasPermission(PERMISSIONS.CREATE_ORDER),
    updateOrder: () => hasPermission(PERMISSIONS.EDIT_ORDER),
    deleteOrder: () => hasPermission(PERMISSIONS.DELETE_ORDER),
    viewOrder: () => hasPermission(PERMISSIONS.VIEW_ORDER),
    approveOrder: () => hasPermission(PERMISSIONS.APPROVE_ORDER),
    consolidateOrders: () => hasPermission(PERMISSIONS.CONSOLIDATE_ORDERS),
    executeDelivery: () => hasPermission(PERMISSIONS.EXECUTE_DELIVERY)
  };

  return {
    can,
    loading,
    error,
    ROLES,
    PERMISSIONS
  };
};

export default usePermissions;
